/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { exportElement as a } from "./export-element.mjs";
function m(r) {
  return (t, o = {}, n) => u(r, t, o, n);
}
function u(r, t, o = {}, n) {
  let e;
  i();
  function i() {
    r(l(), o, p);
  }
  function p() {
    document.body.removeChild(e), e = void 0, n && n();
  }
  function l() {
    e = document.createElement("div"), e.className = "k-grid-pdf-export-element";
    const d = a(t);
    return e.appendChild(d), document.body.appendChild(e), d;
  }
}
export {
  m as provideSaveGridPDF
};
